import React, { useContext, useEffect, useRef, useState } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { Tag } from 'primereact/tag';
import { Avatar } from 'primereact/avatar';
import MenuContext from './pages/MenuContext';

export const AppTopbar = (props) => {

    const [mainModuleName, setMainModuleName] = useState("")

    const menu = JSON.parse(localStorage.getItem("nav"));

    const userName = localStorage.getItem("userName");
    const trimmedUserName = userName?.split("@")[0] ?? "";
    const cleanedUserName = trimmedUserName.replace(/\d+/g, '');
    const avatarLabel = userName.charAt(0) || "";

    const roleName = localStorage.getItem("roleName") || "";
    const companyName = localStorage.getItem("companyName") !== "null" ? localStorage.getItem("companyName") : "";
    const email = localStorage.getItem("userEmail") || ""

    const op = useRef(null);

    const items = [
        {
            label: `Profile ${companyName && ("(" + companyName + ")")}`,
            items: [
                {
                    label: <Tag className="p-mr-2" value={roleName} />,
                },
                {
                    label: cleanedUserName,
                    icon: "pi pi-user"
                },
                {
                    label: email,
                    icon: "pi pi-envelope"
                }
            ]
        },
        {
            label: 'Navigate',
            items: [
                {
                    label: 'Logout',
                    icon: 'pi pi-power-off',
                    command: () => {
                        handleLogout()
                    }
                }
            ]
        }
    ];

    const handleLogout = () => {
        localStorage.clear();
        window.location.reload();
    };

    const { clickedItem } = useContext(MenuContext) || {}

    useEffect(() => {
        const foundItem = menu?.find((item) => {
            const name1 = item?.items?.find((item1) => {
                return item1?.label === clickedItem;
            });
            return name1 !== undefined;
        });

        if (foundItem) {
            setMainModuleName(foundItem?.label)
        } else {
            setMainModuleName("")
        }
    }, [menu, clickedItem]);

    return (
        <div className="layout-topbar clearfix">
            <button type="button" className="p-link layout-menu-button" onClick={props.onToggleMenu}>
                <span className="pi pi-bars" />
            </button>

            <div className='topbar_head'>
                <h3>{mainModuleName}</h3>
            </div>

            <div className="layout-topbar-icons" style={{ display: "flex" }}>

                <div onClick={(e) => op.current.toggle(e)} aria-haspopup aria-controls="overlay_panel" style={{ cursor: "pointer" }}>
                    <Avatar label={avatarLabel && avatarLabel} className="p-mr-2" size="medium" shape="circle" style={{ backgroundColor: "#4e8f8c", color: "#fff" }} />
                    <i className='pi pi-angle-down' style={{ color: "rgb(78 143 140)" }} />
                </div>

                <OverlayPanel ref={op} id="overlay_panel" style={{ width: '450px' }} className="overlaypanel-demo">
                    <Menu model={items} />
                </OverlayPanel>
            </div>
        </div>
    );
};
